angular.module('services.newman.DuplicateService', [
  'global'
])

/**
 * The DuplicateService service provides methods to duplicate items
 *
 * @class DuplicateService
 * @constructor
 * @module services.newman.DuplicateService
 */
.factory('DuplicateService', [
  '$q',
  'GLOBAL',
  'ModelsService',
  'ApiService',
  'CasesService',
  function ($q, GLOBAL, ModelsService, ApiService, CasesService) {
    'use strict';

    var service = {

      dependencies: [],

      defer: null,

      getCopyLabel: function (label, copy) {
        var newLabel = label + ' (copy ' + copy + ')';
        var match = _.find(CasesService.cases, {
          label: newLabel
        });
        if (match) {
          newLabel = service.getCopyLabel(label, copy + 1);
        }
        return newLabel;
      },

      duplicateCase: function (id) {
        var relatives;
        var model = _.cloneDeep(ModelsService.find('cases', 'id', id));

        service.dependencies = [];
        service.defer = $q.defer();

        console.log('duplicateCase', id);
        console.log(model);

        // clean content
        delete model.content.publish;
        delete model.content.published;
        model.content.start = null;
        // filter relatives
        model.relatives = _.reject(model.relatives, { model: 'publications' });
        // sort relatives
        model.relatives = _.sortBy(model.relatives, 'model');
        console.log(model);

        // copy model relatives to variable and clear
        relatives = _.cloneDeep(model.relatives);

        service.dependencies.push({ model: 'cases', oldID: id, newID: uuid.v1() });

        // update relatives id
        relatives = _(relatives)
          .reject({ model: 'cases' })
          .map(function (relative) {
            return {
              model: relative.model,
              oldID: relative.id,
              newID: uuid.v1()
            };
          })
          .value();

        service.dependencies = service.dependencies.concat(relatives);

        $q
          .all(service.loadDependencies(service.dependencies))
          .then(function (response) {
            var subs = [];
            _.forEach(response, function (entry) {
              service.getDependencyById(entry.id, entry.model).oldData = entry;
              if (entry.model === 'states') {
                _.forEach(entry.relatives, function (relative) {
                  if (relative.model === 'decisions' || relative.model === 'rules') {
                    subs.push({ model: relative.model, oldID: relative.id, newID: uuid.v1() });
                  }
                });
              }
            });
            service.dependencies = service.dependencies.concat(subs);
            return $q.all(service.loadDependencies(subs));
          })
          .then(function (subResponse) {
            _.forEach(subResponse, function (entry) {
              service.getDependencyById(entry.id, entry.model).oldData = entry;
            });
            console.log(service.dependencies);
            service.dependencies = service.transformDependencies();
            // Adds (Copy X) to case label
            _.filter(service.dependencies, { model: 'cases' })[0].newData.label = service.getCopyLabel(model.label, 1);
            return service.saveDependencies();
          })
          .catch(function (err) {
            console.log(err);
          });

        return service.defer.promise;
      },

      duplicateState: function (caseRef, state) {
        // add state
        var newState = _.cloneDeep(state);

        console.log('duplicateState', caseRef);
        console.log('duplicateState', state);

        service.dependencies = [];
        service.defer = $q.defer();

        // add case
        service.dependencies.push({ model: 'cases', oldID: caseRef.id, newID: caseRef.id });
        newState.id = uuid.v1();
        service.dependencies.push({ model: 'states', oldID: state.id, newID: newState.id });
        // add state relatives
        _.forEach(state.relatives, function (relative) {
          if (relative.model === 'decisions' || relative.model === 'rules') {
            service.dependencies.push(
              { model: relative.model, oldID: relative.id, newID: uuid.v1() }
            );
          }
        });

        console.log(service.dependencies);

        $q
          .all(service.loadDependencies(service.dependencies))
          .then(function (subResponse) {
            var c;
            var s;
            // add data to dependency
            _.forEach(subResponse, function (entry) {
              service.getDependencyById(entry.id, entry.model).oldData = entry;
            });

            // find the state dependency and swap the id
            s = _.find(service.dependencies, { model: 'states' });
            s.oldID = s.newID;
            console.log(_.cloneDeep(service.dependencies));
            // transform the data
            service.dependencies = service.transformDependencies();
            console.log(_.cloneDeep(service.dependencies));
            // add a new state relative to the case
            c = _.find(service.dependencies, { model: 'cases' });
            c.newData.relatives = CasesService.createRelative(c.newData.relatives, s.newData);
            console.log(c.newData.relatives);
            return service.saveDependencies();
          })
          .catch(function (subResponse) {
            console.log(subResponse);
          });

        return service.defer.promise;
      },

      duplicateWidget: function (caseRef, widget) {
        // add widget
        var newWidget = _.cloneDeep(widget);
        newWidget.id = uuid.v1();

        console.log('duplicateWidget', caseRef);
        console.log('duplicateWidget', widget);

        service.dependencies = [];
        service.defer = $q.defer();

        // add case
        service.dependencies.push({ model: 'cases', oldID: caseRef.id, newID: caseRef.id });
        service.dependencies.push({ model: 'widgets', oldID: widget.id, newID: newWidget.id });

        console.log(service.dependencies);

        $q
          .all(service.loadDependencies(service.dependencies))
          .then(function (subResponse) {
            var c;
            var s;
            // add data to dependency
            _.forEach(subResponse, function (entry) {
              service.getDependencyById(entry.id, entry.model).oldData = entry;
            });

            // find the widget dependency and swap the id
            s = _.find(service.dependencies, { model: 'widgets' });
            s.oldID = s.newID;
            console.log(_.cloneDeep(service.dependencies));
            // transform the data
            service.dependencies = service.transformDependencies();
            console.log(_.cloneDeep(service.dependencies));
            // add a new widget relative to the case
            c = _.find(service.dependencies, { model: 'cases' });
            c.newData.relatives = CasesService.createRelative(c.newData.relatives, s.newData);
            console.log(c.newData.relatives);
            return service.saveDependencies();
          })
          .catch(function (subResponse) {
            console.log(subResponse);
          });

        return service.defer.promise;
      },

      /**
       * Loops through and post all new dependicies
       *
       * @return {Promise<Array>} resolves to an array of dependencies
       */
      saveDependencies: function saveDependencies() {
        var queue = [];

        _.forEach(service.dependencies, function (entry) {
          var model = {
            content: entry.newData.content,
            label: entry.newData.label,
            relatives: entry.newData.relatives,
            id: entry.newData.id
          };
          var href = _.find(entry.newData.crud, { id: 'put' }).href;
          var reg = new RegExp(/[\w]{8}-[\w]{4}-[\w]{4}-[\w]{4}-[\w]{12}/, 'g');

          console.log(entry);
          console.log(entry.newData.crud);

          href = href.replace(reg, '');

          console.log(href);

          // queue.push(ModelsService.update(entry.newData, model));
          queue.push(ApiService.execute(href, 'PUT', model));
        });

        console.log(queue);

        $q
          .all(queue)
          .then(function (response) {
            console.log('Dependencies Saved', response);
            return service.defer.resolve(response);
          })
          .catch(function (response) {
            console.log(response);
            return service.defer.reject(response);
          });
      },

      /**
       * Loops through all dependencies and makes ID changes
       *
       * @return {Array<Object>} all dependencies
       */
      transformDependencies: function transformDependencies() {
        console.log(service.dependencies);

        _.forEach(service.dependencies, function (entry) {
          var newData = _.cloneDeep(entry.oldData);
          newData.id = entry.newID;
          newData.relatives = service.transformRelatives(newData);
          newData.content = service.transformContent(newData);
          newData.crud = service.transformCrud(newData, entry.oldID);

          console.log(entry);

          entry.newData = newData;
        });

        console.log(service.dependencies);

        return service.dependencies;
      },

      /**
       * Transforms IDs in relatives
       *
       * @param {Object} newData - Data object
       * @return {Array<Object>} Updated relatives array
       */
      transformRelatives: function transformRelatives(newData) {
        _.forEach(newData.relatives, function (relative) {
          var newRelative = service.getDependencyById(relative.id, relative.model);
          relative.id = newRelative.newID;
        });

        return newData.relatives;
      },

      /**
       * Transforms IDs in content
       *
       * @param {Object} newData - Data object
       * @return {Object} Updated content object
       */
      transformContent: function transformContent(newData) {
        if (newData.model === 'cases') {
          console.log(_.cloneDeep(newData.content));
          newData.content.start = service.getDependencyById(newData.content.start, 'states').newID;
          console.log(_.cloneDeep(newData.content));
        } else if (newData.model === 'states') {
          console.log(_.cloneDeep(newData.content));
          newData.content.decisions = _.map(newData.content.decisions, function (entry) {
            return service.getDependencyById(entry, 'decisions').newID;
          });
          newData.content.rules = _.map(newData.content.rules, function (entry) {
            return service.getDependencyById(entry, 'rules').newID;
          });
          console.log(newData.content);
        } else if (newData.model === 'rules') {
          console.log(_.cloneDeep(newData.content));
          // DCS parsing
          if (newData.content.decision) {
            // var decision = _.cloneDeep(newData.content.decision);
            newData.content.decision.incorrectTarget = service
              .getDependencyById(newData.content.decision.incorrectTarget, 'states').newID;
            newData.content.decision.correctTarget = service
              .getDependencyById(newData.content.decision.correctTarget, 'states').newID;
            _.forEach(newData.content.decision.choices, function (entry) {
              entry.target = service.getDependencyById(entry.target, 'states').newID;
            });
          }
          // novex parsing
          if (newData.content.target) {
            newData.content.target = service
              .getDependencyById(newData.content.target, 'states').newID;
          }
          console.log(_.cloneDeep(newData.content));
        }

        return newData.content;
      },

      /**
       * Transforms IDs in crud
       *
       * @param {Object} newData - Data object
       * @param {string} oldID - Old ID to transform
       * @return {Object} Updated crud object
       */
      transformCrud: function transformCrud(newData, oldID) {
        var crud = JSON.stringify(newData.crud);
        var reg = new RegExp(oldID, 'g');

        console.log(_.cloneDeep(newData.crud));
        crud = crud.replace(reg, newData.id);

        newData.crud = JSON.parse(crud);

        console.log(_.cloneDeep(newData.crud));

        return newData.crud;
      },

      /**
       * Returns a dependency based on the provided id and model
       * NOTE: Compares against oldID
       *
       * @param {string} id - identifier
       * @param {string} model - Model type
       * @return {Object} Dependency objjet
       */
      getDependencyById: function getDependencyById(id, model) {
        var dep = _.find(service.dependencies, { oldID: id, model: model });

        if (!dep) {
          dep = { model: model, oldID: id, newID: id };
        }

        return dep;
      },

      /**
       * Produces a queue based on provided list
       *
       * @param {Array<Object>} list - Dependency list
       * @return {Array<Object>} Load queue
       */
      loadDependencies: function loadDependencies(list) {
        var queue = _.map(list, function (entry) {
          return ModelsService
            .get(entry.model, GLOBAL.apiPath + '/' + entry.model, { id: entry.oldID });
        });

        console.log(queue);

        return queue;
      }

    };

    return service;
  }
]);
